<template>
    <div class="DataTableModalSearchPartsComponent  DataTables">
        <p>{{lang.infotext_2}}:</p>
        <div :id="id">
            <LoaderComponent v-if="!isData"></LoaderComponent>
            
        </div>
        <br><br>
        <div id="checkbox_container" class="checkbox_container">

        <b-form-checkbox id="checkbox-showAll"  v-model="showAllStatus" :value="true" :unchecked-value="false">
            {{lang.label_checkbox}}
        </b-form-checkbox>
        </div>
    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '../../Tools/Tools';
import dt from 'datatables.net-bs4';




require("datatables.net-select-bs4");
require("datatables.net-keytable");


import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"

import { mapGetters } from 'vuex'
export default {
    name: 'DataTableModalSearchPartsComponent',
    props: {
        lang: Object,
        source: String,
        data: Object
    },
    components: {
        LoaderComponent,
        

    },
    data() {
        return {
            name: "DataTableModalSearchPartsComponent",
            id: "tableplace_" + this._uid,
            columns: [],
            colsAssign: [],
            activeActionIds: [],
            
            contextMenu: {},
            
            visibility: ["NotExposed", "ExposedToTables", "TransferredToDesign", "ForceDisplayed", "ForceHidden"],
            lengthMenu: 20,
            showAllStatus: true,
            isShowAll: false,
        }
    },
    computed: {
        ...mapGetters({

            isPlugin: "isPlugin",


        }),
        currentUser() {
            return this.$store.getters.currentUser;
        },
        categoryId() {
            if (this.$store.getters.selectedSearchPartsTreeItemObject == undefined) {
                return 1;
            } else {
                return this.$store.getters.selectedSearchPartsTreeItemObject.categoryId;
            }
        },
        selectedSearchPartsTreeItemObject() {

            return this.$store.getters.selectedSearchPartsTreeItemObject
        },
        activeActions() {

            return this.$store.getters.pm_activeActions
        },
        isData() {

            return false
        },
        /*server(){
    
          return this.$store.getters.server;
        },*/
        reloadedAfterAction() {
            return this.$store.getters.reloadedAfterAction;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        // showAllStatus2: {
        //     get: function() {
        //         if (this.data == null) {
        //             return true;
        //         }
        //         return false;
        //     },
        //     set: function (newVal) {
                
        //         this.showAllStatus = newVal;
        //     }
            
        // },
        partsSimilarByFootprintTo() {

            if (this.data.form == null) {

                return null;
            }
            let trig1 = false;
            let trig2 = false;

            if (this.data.form.partNumber != "" && this.data.form.partNumber != null && this.data.form.partNumber != undefined) {
                trig1 = true;
            }

            if (this.data.form.revision != "" && this.data.form.revision != null && this.data.form.revision != undefined) {
                trig2 = true;
            }

            if (trig1 == true && trig2 == true) {
                return {
                    partNumber: this.data.form.partNumber,
                    revision: parseInt(this.data.form.revision)
                }
            } else {
                return null;
            }
            
            
        }

    },
    created() {

        if (this.data.isCheckBoxShowAll == false) {
            this.showAllStatus = false;
        } else {
            this.showAllStatus = true;
        }
        

        this.activeActionIds = [];

        

        for (let i = 0, lei = this.activeActions.length; i < lei; i++) {

            const obj = {
                actionId: this.activeActions[i].actionId
            }
            this.activeActionIds.push(obj);
        }

    },
    watch: {
        categoryId: function (newVal, oldVal) {
            console.log("categoryId", newVal, oldVal)
            this.getProperties();
        },
        activeActions: {
            handler: function (newVal, oldVal) {

                this.activeActionIds = [];
                for (let i = 0, lei = this.activeActions.length; i < lei; i++) {

                    const obj = {
                        actionId: this.activeActions[i].actionId
                    }
                    this.activeActionIds.push(obj);
                }



                this.getProperties();
            },
            deep: true
        },
        selectedSearchPartsTreeItemObject: function (newVal, oldVal) {

            //this.getProperties();
        },
        reloadedAfterAction: function (newValue, oldValue) {


            if (newValue.name == this.name) {
                if (newValue.status == true) {

                    this.getProperties();

                    newValue.status = false;
                    newValue.name = "";
                    this.$store.dispatch("reloadAfterAction", newValue);
                }
            }

        },
        showAllStatus: function (newVal, oldVal) {
            
            this.getProperties();
        }

    },
    
    updated() {

    },
    mounted: function () {
        this.$store.dispatch("deleteAllSelectedSearchPartRows");
        this.getProperties();


    },
    methods: {
        getProperties() {

            let vue = this;

            let categoryId = 1;
            if (this.selectedSearchPartsTreeItemObject.categoryId != undefined) {
                categoryId = this.selectedSearchPartsTreeItemObject.categoryId;
            }

            const obj = {
                categoryId: categoryId,
                actions: []
            }

            this.$store.dispatch("pm_getProperties", obj)
                .then((result) => {

                    console.log(result)
                    vue.buildColumns(result.data)

                })

        },


        buildColumns(properties) {
            this.columns = [
                {
                    name: "Id",
                    alignInColumn: "left",
                    propertyId: "",
                    type: "text"
                },
                {
                    name: this.lang.header_Image,
                    alignInColumn: "left",
                    propertyId: "",
                    type: "image"
                },
                {
                    name: this.lang.header_Status,
                    alignInColumn: "left",
                    propertyId: "",
                    type: "text"
                },
                {
                    name: this.lang.header_Revision,
                    alignInColumn: "left",
                    propertyId: "",
                    type: "text"
                },
            ];

            this.colsAssign = [
                { "data": "col___revisionId" },
                { "data": "col___image" },
                { "data": "col___status" },
                { "data": "col___revision" },

            ]

            properties.sort(function (a, b) { return a.priority - b.priority });

            for (let i = 0, lei = properties.length; i < lei; i++) {

                if (this.selectedSearchPartsTreeItemObject.categoryId == 1) {

                    if (properties[i].origins == "own") {

                        let obj = {
                            name: properties[i].name,
                            alignInColumn: "left",
                            propertyId: properties[i].propertyId,
                            type: properties[i].type,

                        }
                        this.columns.push(obj);

                        let objAssign = {
                            data: "col___" + properties[i].propertyId

                        }

                        this.colsAssign.push(objAssign)
                    } else {

                    }

                } else {

                    let obj = {
                        name: properties[i].name,
                        alignInColumn: "left",
                        propertyId: properties[i].propertyId,
                        type: properties[i].type,

                    }
                    this.columns.push(obj);

                    let objAssign = {
                        data: "col___" + properties[i].propertyId

                    }

                    this.colsAssign.push(objAssign)
                }

            }



            this.buildTable();
        },


        buildTable() {


            //let lengthMenu = 20;



            // if (this.$store.getters.outerData != true) {

            //     this.$store.dispatch("deleteAllSelectedRows");
            //     this.$store.dispatch("setOuterData", false);
            // }

            var tableplace = document.getElementById("tableplace_" + this._uid);

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var place = document.createElement("table");
            place.setAttribute("id", "place" + this._uid);
            place.setAttribute("class", "table table-striped table-bordered");
            place.setAttribute("style", "width:100%;");
            tableplace.appendChild(place)

            var tr1 = document.createElement("tr");
            tr1.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr1);
            place.appendChild(thead);

            var tr2 = document.createElement("tr");
            tr2.setAttribute("class", "cellFooter");
            var tfoot = document.createElement("tfoot");
            tfoot.appendChild(tr2);
            place.appendChild(tfoot);



            var columnDefs = [];


            let _vue = this;

            var len = this.columns.length;

            let y = 0;

            for (let i = 0; i < len; i++) {

                let el = {
                    targets: i,
                    className: '_dt-body-' + _vue.columns[i].alignInColumn,
                    render: function ( data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                        if (meta.col == 0) {
                            if (data.name == "revisionId") {
                                return data.revisionId
                            }

                        }

                        let toDisplay = "";
                        if (data == undefined) {

                            data = {
                                value: {
                                    display: "<span style='color:red'>! " + meta.col + "-" + meta.row + "</span"
                                }
                            }
                        }


                        if (data.value != null) {
                            toDisplay = data.value.display;
                        }

                        if (meta.col == 1) {


                            if (y < _vue.lengthMenu) {

                                if (data.name == "image") {
                                    let image = "";
                                    if (data.assembly == true) {
                                        image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/assembly.svg\" class=\"image-category\">";
                                    } else {

                                        if (data.value.display == "default") {
                                            image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/default.svg\" class=\"image-category\">";
                                        } else if (data.value.display == "electrical-part") {
                                            image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/electrical-part.svg\" class=\"image-category\">";
                                        } else if (data.value.display == "mechanical-part") {
                                            image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/mechanical-part.svg\" class=\"image-category\">";
                                        } else if (data.value.display == "software-part") {
                                            image = "<img id=\"image__" + data.revisionId + "\" class=\"image-svg\" src=\"/static/software-part.svg\" class=\"image-category\">";
                                        } else {
                                            image = "<img id=\"image__" + data.revisionId + "\" src=\"\" class=\"image-category\">";



                                            const obj = {
                                                fileName: toDisplay
                                            }
                                            _vue.$store.dispatch("getImage", obj)
                                                .then((result) => {

                                                    if (result != null) {

                                                        let img = document.getElementById("image__" + data.revisionId);

                                                        if (img != null) {
                                                            //console.log(result)
                                                            img.src = URL.createObjectURL(result);

                                                            img.addEventListener('load', () => URL.revokeObjectURL(result), { once: true });
                                                        }

                                                    }

                                                })
                                        }

                                    }



                                    y++;
                                    return image;
                                }

                            }



                        }
                        if (meta.col == 2) {
                            if (data.name == "status") {

                                let status = "";
                                let variant = Tools.getStatusColor(toDisplay);
                                status += "<b-badge class='badge badge-" + variant + " '>" + toDisplay + "</b-badge>";
                                if (data.used == true) {
                                    status += "<b-badge class='badge badge-info '>" + _vue.lang.status_Used + "</b-badge>";
                                }
                                if (data.physical == false && data.assembly != true) {

                                    status += "<b-badge class='badge badge-diff '>" + _vue.lang.status_Alternative + "</b-badge>";
                                }

                                if (data.assembly == true) {
                                    status += "<b-badge class='badge badge-blue '>" + _vue.lang.status_Assembly + "</b-badge>";
                                }
                                return "<div class=\"badges\">" + status + "</div>";
                            }
                        }



                        if (data.type == "part number") {

                        }
                        if (data.type == "link") {
                            let link = "";
                            if (toDisplay != null) {
                                link = toDisplay;
                                toDisplay = "<a href='" + link + "' target='_blank'>Link</a>"
                            } else {
                                toDisplay = "";
                            }

                        }
                        if (data.type == "image") {

                            toDisplay = "<img height='20px' src='" + toDisplay + "'>"
                        }



                        return toDisplay;



                    }
                }



                columnDefs.push(el);




                var th1 = document.createElement("th");

                tr1.appendChild(th1);

                var br = document.createElement("br");
                var tx = document.createTextNode(this.columns[i].name);
                th1.appendChild(br);
                th1.appendChild(tx);

            }

            let vue = this;


            var option = {};


            option.keys = false;
            //json.data= datatable;
            option.myColumnFormats = this.columns;
            option.colReorder = false;
            option.lengthMenu = [[20, -1], [20, "All"]];
            option.order = [[4, "asc"]];
            option.select = true;
            option.columns = this.colsAssign;
            option.columnDefs = columnDefs;
            if (this.isPlugin) {
                option.dom = '<fr<t>ip>';
            } else {
                option.dom = '<f<"#info-showall">r<t>ip>';
            }

            option.processing = true;
            option.serverSide = true;
            // option.search = {
            //   regex: true
            // }
            // option.buttons = [
            //     {
            //         text: 'Show all',
            //         action: function (e, dt, node, config) {
            //             console.log(this)
            //             console.log(e)
            //             console.log(dt)
            //             console.log(node)
            //             console.log(config)
            //             if (node.text() == 'Show all') {

            //                 //show all

            //                 node.text("Show selected");
            //                 console.log("Show selected")
            //                 vue.showAll == true;
            //             } else {

            //                 //show selected
            //                 node.text("Show all");
            //                 console.log("Show all")
            //                 vue.showAll == false;
            //             }
            //         }
            //     },
            // ]
            option.initComplete = function (settings, json) {
                console.log("complete")

                this.api().columns().every(function () {
                    var column = this;

                    if (vue.columns[column[0][0]].type != "image") {
                        var select = $('<select><option value=""></option></select>')
                            .appendTo($(column.footer()).empty())
                            .on('change', function () {

                                var val = $.fn.dataTable.util.escapeRegex(
                                    $(this).val()
                                );

                                column
                                    .search(val ? val : '', true, false)
                                    .draw();
                            });
                        let arr = [];
                        column.data().unique().sort().each(function (d, j) {
                            if (d == null) {
                                return
                            }

                            if (d.value.display != null) {

                                //if (!arr.includes(d.value.display)){
                                arr.push(d.value.display);
                                select.append('<option value="' + d.value.display + '">' + d.value.display + '</option>');
                                //}

                            }


                        });
                    }

                });
                console.log(vue.data)
                if (vue.data.isCheckBoxShowAll == true) {

                    let checkbox_container = document.getElementById("checkbox_container");
                    console.log(checkbox_container)
                    if (checkbox_container != null) {
                        let newCheckbox = checkbox_container.firstChild.cloneNode(true);
                        newCheckbox.firstChild.setAttribute("id", "checkbox_element")
                        newCheckbox.classList.add("newCheckBox_container")
                        console.log(newCheckbox)
                        let info_showall = document.getElementById("info-showall");

                        if (info_showall != null) {

                            while (info_showall.firstChild) {
                                info_showall.removeChild(info_showall.firstChild);
                            }

                            info_showall.appendChild(newCheckbox);
                        }
                    }
                }



            }
            option.fnDrawCallback = function (oSettings) {

                //vue.buildContextMenu();
            }
            

            option.ajax = {
                url: /*this.server + */"/api/v3/partmanagement/parts/GetParts",

                crossDomain: true,
                type: 'POST',
                dataType: 'json',
                cors: true,
                contentType: 'application/json',
                secure: false,
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // console.log(xhr)
                    // console.log(xhr.status)
                    // console.log(thrownError)
                    if (xhr.responseJSON.message == "Authorization failure.") {

                        vue.$store.dispatch("ogout");
                    }

                },
                data: function (json) {


                    let categoryId = 1;

                    if (vue.categoryId != undefined) {

                        categoryId = vue.categoryId;
                    }

                    json.categoryId = categoryId;

                    let actions = [];
                    json.actions = [];

                    if (vue.showAllStatus == false) {
                        json.partsSimilarByFootprintTo = null;
                        
                    } else {
                        json.partsSimilarByFootprintTo = vue.partsSimilarByFootprintTo;
                        
                    }
                    
                    
                    
                    

                    for (let i = 0, lei = json.columns.length; i < lei; i++) {
                        json.columns[i].col = i;
                    }

                    console.log(json)

                    return JSON.stringify(json);
                },
                dataFilter: function (data) {
                    
                    y = 0;
                    var json = jQuery.parseJSON(data);
                    console.log(json)

                    let newJson = {
                        draw: json.data.draw,
                        recordsFiltered: json.data.recordsFiltered,
                        recordsTotal: json.data.recordsTotal,
                        data: []
                    }
                    let rows = [];
                    vue.lengthMenu = json.data.data.length;
                    for (let i = 0, lei = json.data.data.length; i < lei; i++) {

                        let row = {};
                        let objId = {
                            partId: json.data.data[i].partId,
                            revisionId: json.data.data[i].revisionId,
                            name: "revisionId",
                            type: "text",
                            categoryId: json.data.data[i].categoryId,
                            categoryName: json.data.data[i].categoryName,
                            category: json.data.data[i].category,
                            requestorUserId: json.data.data[i].requestorUserId,
                            value: {
                                display: json.data.data[i].revisionId,
                                filter: json.data.data[i].revisionId,
                                sort: json.data.data[i].revisionId
                            }
                        };

                        let revisionId = "col___revisionId";
                        row[revisionId] = objId;

                        let objImage = {
                            partId: json.data.data[i].partId,
                            revisionId: json.data.data[i].revisionId,
                            name: "image",
                            type: "image",
                            categoryId: json.data.data[i].categoryId,
                            categoryName: json.data.data[i].categoryName,
                            category: json.data.data[i].category,
                            used: json.data.data[i].used,
                            assembly: json.data.data[i].assembly,
                            physical: json.data.data[i].physical,
                            value: {
                                assembly: json.data.data[i].assembly,
                                display: json.data.data[i].imagepath,
                                filter: json.data.data[i].imagepath,
                                sort: json.data.data[i].imagepath
                            }
                        };

                        let image = "col___image";
                        row[image] = objImage;

                        let objStatus = {
                            partId: json.data.data[i].partId,
                            revisionId: json.data.data[i].revisionId,
                            name: "status",
                            type: "text",
                            categoryId: json.data.data[i].categoryId,
                            categoryName: json.data.data[i].categoryName,
                            category: json.data.data[i].category,
                            used: json.data.data[i].used,
                            assembly: json.data.data[i].assembly,
                            physical: json.data.data[i].physical,
                            value: {
                                display: json.data.data[i].status,
                                filter: json.data.data[i].status,
                                sort: json.data.data[i].status
                            }
                        };

                        let status = "col___status";
                        row[status] = objStatus;

                        let objRevision = {
                            partId: json.data.data[i].partId,
                            revisionId: json.data.data[i].revisionId,
                            name: "revision",
                            type: "text",
                            categoryId: json.data.data[i].categoryId,
                            categoryName: json.data.data[i].categoryName,
                            category: json.data.data[i].category,
                            value: {
                                display: json.data.data[i].revision,
                                filter: json.data.data[i].revision,
                                sort: json.data.data[i].revision
                            }
                        };

                        let revision = "col___revision";
                        row[revision] = objRevision;

                        for (let j = 0, lej = json.data.data[i].properties.length; j < lej; j++) {

                            let obj = {
                                propertyId: json.data.data[i].properties[j].propertyId,
                                name: json.data.data[i].properties[j].name,
                                value: {
                                    display: json.data.data[i].properties[j].value_display,
                                    filter: json.data.data[i].properties[j].value_filter,
                                    sort: json.data.data[i].properties[j].value_sort
                                },
                                type: json.data.data[i].properties[j].type,
                                visibility: json.data.data[i].properties[j].cisDesignation

                            }

                            let key = "col___" + json.data.data[i].properties[j].propertyId;
                            row[key] = obj;



                        }

                        rows.push(row);
                    }


                    newJson.data = rows;

                    console.log(newJson)

                    return JSON.stringify(newJson);
                },

            }



            if ($.fn.dataTable.isDataTable('#place' + this._uid)) {
                this.mainTable.destroy();

            }
            
            this.mainTable = $('#place' + this._uid).DataTable(option);

            this.mainTable.column(0).visible(false);

            let el = document.getElementsByClassName("dataTables_processing")[0]
            
            
                           
            el.classList.add("processing-top-modal");
            


            //search input change view
            var searchplace = document.getElementById("place" + this._uid + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }


            searchplace.firstChild.setAttribute("placeholder", "Enter search words")
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
            searchplace.firstChild.addEventListener("input", function (evt) {

                _vue.$store.dispatch("setFilteredData", evt.target.value);

            })

            // let lengthplace = document.getElementById("place" + this._uid + "_length");

            // if (lengthplace.firstChild.firstChild != null) {
            //     lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
            // }

            let _mainTable = this.mainTable;
            this.mainTable
                .on('select', function (e, dt, type, indexes) {
                    //var rowData = _mainTable.rows( indexes ).data().toArray();
                    var rowData = _mainTable.rows(indexes).data();



                    
                    if (_vue.source == "modalSearchParts") {
                        

                        let partNumber = null;
                        let description = "";
                        for (let el in rowData[0]) {
                            if (rowData[0][el].type == "part number") {
                                partNumber = rowData[0][el].value.display;
                            }
                            if (rowData[0][el].type == "description") {
                                description = rowData[0][el].value.display;
                            }
                        }

                        const obj = rowData[0].col___revisionId;
                        obj.partNumber = partNumber;  
                        obj.revision = rowData[0].col___revision.value.display;  
                        obj.description = description;
                        obj.assembly = rowData[0].col___status.assembly;
                        console.log(obj)
                        _vue.$store.dispatch("setSelectedSearchPartRows", obj);

                    } 


                })
                .on('deselect', function (e, dt, type, indexes) {

                    _vue.$store.dispatch("deleteAllSelectedSearchPartRows");

                    
                });
            


        },
        


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.DataTableModalSearchPartsComponent {
    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;
        white-space: nowrap;
    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
        position: absolute;
        top: -20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .processing-top {
        top: 50px;
    }
    .processing-top-modal {
        top: -20px;
    }

    

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .dataTables_length {
        margin-left: 20px;
        width: 200px;
        float: left;
    }

    .dataTables_length label {
        display: inline-flex;
    }

    .select-length {
        padding: 0.1rem;
        margin-left: 10px;
        margin-right: 10px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        //margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.25rem 0.5rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
        width: 300px;
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .image-category {
        max-width: 40px;
        //border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;

    }

    .badge {
        margin-right: 1px;

        margin-bottom: 2px;
    }

    .badges {
        margin-top: 3px;
        margin-bottom: 2px;
    }

    .image-svg {
        max-width: 40px;
        //border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-right: 3px;
        margin-bottom: 3px;
        background-color: white;
        padding: 2px;
    }
    .checkbox_container{
        display: none;
    }
    .newCheckBox_container{
        margin-left: 220px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/DataTableModalSearchPartsComponent.vue